import { brandPrimary, white } from '../../styles/colors';

export const MAX_CONTENT_LENGTH = 450;

export const IMAGE_DIMENSIONS = {
	width: 1080,
	height: 566,
} as const;

export const DEFAULT_COLORS = {
	background: brandPrimary,
	text: white,
	star: '#FFD700', // TODO: Add to colors.ts
} as const;

export const DEFAULT_POST_DESCRIPTIONS = [
	'Hear directly from our customers — their experience speaks volumes.',
	'Proud to share this recent feedback from one of our valued clients.',
	"Customer satisfaction is at the heart of what we do. Here's what people are saying.",
	"We're grateful for the trust our clients place in us. Here's one of their stories.",
	'Real results. Real feedback. See what our customers have to say.',
	"We strive for excellence — and it's always rewarding to hear when we've delivered.",
	'A recent review that reminds us why we do what we do.',
	'Client feedback like this drives our team to keep raising the bar.',
] as const;

/** The testimonial background's fixed shape, which its crop is locked to. */
export const TESTIMONIAL_ASPECT_RATIO = IMAGE_DIMENSIONS.width / IMAGE_DIMENSIONS.height;
